import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { DownloadTemplateRequestModel } from "@/features/accounts/csv-excel/services/download-template-model";
import { HttpResponse } from "@/shared/config/globals";

export class DownloadExcelTemplateApi {
  /**
   * Excel雛形取得API
   */
  public downloadExcelTemplate = async (
    param: DownloadTemplateRequestModel
  ): Promise<HttpResponse<Blob>> => {
    const path = `/api/csvexcelaccounts/download/template`;
    const res = await ApiClient.instance.getBlob<Blob>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res;
  };
}
